<template>
  <el-dialog
      title="验证身份"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      class="abow_dialog"
      width="25%">
    <el-form
        :model="firstData"
        label-width="80px"
        ref="form"
        :rules="firstRules"
        :inline="true"
    >
      <el-form-item label="手机号：" prop="phone">
        <el-input v-model="firstData.phone" disabled></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="phoneCode">
        <div style="display: flex">
          <el-input
              placeholder="请填写验证码"
              v-model.trim="firstData.phoneCode"
          ></el-input>
          <el-button
              type="primary"
              style="margin-left: 5px"
              @click="getPhoneCode()"
              :disabled="firstCodeShow"
          >{{ firstCodeMessage }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="check">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    applicationId: {
      default: () => ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      firstCodeShow: false,
      firstCodeMessage: '获取验证码',
      threeMin: 60,
      firstData: {
        phone: this.$store.state.user.phone,
        phoneCode: "",
      },
      firstRules: {
        phoneCode: [
          {
            required: true,
            message: "请填写验证码",
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    open() {
      this.firstData.phoneCode = '';
      this.dialogVisible = true;
    },
    //获取手机验证码
    getPhoneCode() {
      let url = `/Opencloud/Application/SendPhoneCodeAppKey`;
      this.$axios.get(url).then((res) => {
        if (res) {
          this.$message({
            message: "验证码发送成功！",
            type: "success",
          });
          this.phoneCodeCount();
        }
      });
    },
    //验证码倒计时
    phoneCodeCount() {
      this.threeTimer = setInterval(() => {
        if (this.threeMin > 1) {
          this.firstCodeShow = true;
          this.threeMin--;
          this.firstCodeMessage = this.threeMin + '秒后重试';
        } else {
          clearInterval(this.threeTimer);
          this.firstCodeShow = false;
          this.firstCodeMessage = '获取验证码';
          this.threeMin = 60;
        }
      }, 1000);
    },
    check() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            applicationId: this.applicationId,
            phoneCode: this.firstData.phoneCode,
          }
          this.$axios.post(`/Opencloud/Application/AppKeyByPhoneCode`,obj).then((res) => {
            this.$emit('showKey',res);
            this.$message.success('验证成功！')
          })
          this.dialogVisible = false;
        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style scoped>

</style>